<template>

  <app-layout title="Смартфоны/Планшеты">

    <div
      class="buymodal">
      <h2
        v-if="model && user.flowType!='mvm'"
        class="buymodal-title">
        <div class="barcode">
          <VueBarcode v-bind:value="model.btag" format="CODE128" background="rgba(255,255,255,0)" displayValue="false" height="50" margin="0">
          </VueBarcode>
        </div>
        Заявка №{{ model.btag }}
        
      </h2>
      <div
        class="buymodal-block">

          <buymodal-header
          :headers="headers" />
        
        <transition
          name="slide-left"
          mode="out-in">
          <div
          class="buymodal-block__loader"
          v-if="calculation || loading">
            <v-progress-circular
              :size="70"
              :width="7"
              color="grey"
              indeterminate
            ></v-progress-circular>
            <div><br></div>
            <div>Выполняем операцию. Не закрывайте окно и подождите несколько секунд</div>
          </div>
          <screen-one
            v-if="!loading && headers[0].screenWin"
            @leave="leave()"
            @changeScreen="changeScreen" />

          <screen-two
            v-if="!loading && headers[1].screenWin"
            @leave="leave()"
            @changeScreen="changeScreen"
            :changeScreenFunction="changeScreen" />

          <!-- <screen-three
            v-if="!loading && headers[2].screenWin"
            @leave="leave()"
            @changeScreen="changeScreen" /> -->
          <screen-three
            v-if="!loading && headers[2].screenWin"
            @leave="leave()"
            @changeScreen="changeScreen"
            :changeScreenFunction="changeScreen" />

          <screen-four
            v-if="!loading && headers[3].screenWin"
            @leave="leave()"
            @changeScreen="changeScreen" />
            

        </transition>

      </div>
    </div>

    <refuse-modal
      @cancel="cancel" />

    <icloud-error />
    <scorring-popup />

  </app-layout>

</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';

import AppLayout from '../components/AppLayout.vue';
import BuymodalHeader from './components/AppleWatch/BuymodalHeader';

import ScreenOne from './components/BuyPhones/Screens/ScreenOne';
import ScreenTwo from './components/BuyPhones/Screens/ScreenTwo';
import ScreenThree from './components/BuyPhones/Screens/ScreenThree';
import ScreenFour from './components/BuyPhones/Screens/ScreenFour';

import RefuseModal from '@/components/Modals/RefuseModal';
import IcloudError from '@/components/Modals/IcloudError';
import ScorringPopup from '@/components/Modals/ScorringPopup';

import VueBarcode from 'vue-barcode';

export default {
  name: 'buy-phones',
  components: {
    AppLayout,
    BuymodalHeader,
    ScreenOne,
    ScreenTwo,
    ScreenThree,
    ScreenFour,
    RefuseModal,
    IcloudError,
    ScorringPopup,
    VueBarcode,
  },
  data() {
    return {
      mtsAutoAdvanceStarted: false,
      headers: [
        { name: 'Поиск устройства', screenWin: true, active: true, position: 0},
        { name: 'Расчет цены', screenWin: false, active: false, position: 1},
        { name: 'Данные клиента', screenWin: false, active: false, position: 2},
        { name: 'Подтверждение', screenWin: false, active: false, position: 3},
      ],
    }
  },
  created() {
    this.RESET_PHONES();
    const { params,query } = this.$route;

    var contractId = null;
    if (params && params.btag)
      contractId = params.btag
    if (query && query.contractId)
      contractId = query.contractId
    if ( contractId ) {
      // Restoring an existing order must not start a fresh assessment.
      this.mtsAutoAdvanceStarted = true;
      (async () => {
        await this.getOrder({ btag: contractId });
        this.headers.map((item, i) => {
          item.screenWin = false;
          if (i <= 2) {
            item.active = true;
          }
          if (i == 2) {
            item.screenWin = true;
          }
        })
      })()
    }
  },
  computed: {
    ...mapState('buyphones', ['model', 'loading', 'calculation']),
    ...mapState('user', ['user']),
  },
  watch: {
    model(value) {
      if (!value) {
        return;
      }
      this.tryAutoAdvanceMts();
    },
    loading(value) {
      if (!value) {
        this.tryAutoAdvanceMts();
      }
    }
  },
  methods: {
    ...mapActions('buyphones', ['cancelModel', 'searchModel', 'getOrder', 'getCalc']),
    ...mapMutations('buyphones', ['RESET_PHONES', 'CHANGE_SCREEN_THREE']),
    ...mapMutations('layout', ['SET_REFUSE_MODAL']),
    async tryAutoAdvanceMts() {
      if (
        !this.user ||
        this.user.flowType !== 'mts' ||
        !this.model ||
        this.loading ||
        this.calculation ||
        !this.headers[0].screenWin ||
        this.mtsAutoAdvanceStarted
      ) {
        return;
      }

      this.mtsAutoAdvanceStarted = true;

      try {
        const calcResponse = await this.getCalc({
          btag: this.model.btag,
          questions: "",
        });

        if (!this.isValidMtsAutoAdvanceCalcResponse(calcResponse)) {
          this.mtsAutoAdvanceStarted = false;
          return;
        }

        this.CHANGE_SCREEN_THREE({
          show1: true,
          show2: false,
          show3: false,
          show4: false
        });
        this.changeScreen({ type: 'next', id: 0 });
        this.changeScreen({ type: 'next', id: 1 });
      } catch (e) {
        this.mtsAutoAdvanceStarted = false;
        throw e;
      }
    },
    isValidMtsAutoAdvanceCalcResponse(response) {
      return !!response
        && !response.ErrorDetails
        && !response.error
        && Object.prototype.hasOwnProperty.call(response, 'price');
    },

    leave() {
      this.SET_REFUSE_MODAL({ bg: true, modal: true });
    },

    async cancel(data) {
      const response = await this.cancelModel({
        btag: this.model.btag,
        refuseId: data.id,
      });
      this.RESET_PHONES();
      this.mtsAutoAdvanceStarted = false;
      this.headers.map(item => {
        item.screenWin = false;
        item.active = false;
      })
      this.headers[0].screenWin = true;
      this.headers[0].active = true;
    },
    changeScreen(data) {
      const type = data.type;
      const id = data.id;
      
      let num = 0;
      if (type == 'next') {
        num = id + 1;
        this.headers[num-1].active = true;
      } else if (type == 'prev') {
        num = id - 1;
        this.headers[id].active = false;
      }
      
      // Обновляем позиции всех заголовков
      for (const i in this.headers) {
        this.headers[i].position = i - num;
      }
      
      this.headers[id].screenWin = false;
      this.headers[num].screenWin = true;
      
      // Принудительно обновим компонент - это может быть решением
      this.$forceUpdate();
    }
  }
};
</script>

<style lang="sass">
  @import '@/styles/views/buyphones.sass'
</style>
